// How the verifier dashboard (pages/InstitutionDashboard.jsx) names a
// verification request. The fields are the ones the request lists carry
// (verifications.service.ts listForVerifier): the professional's first and
// last name and the credential's title. A missing value is shown as missing,
// never replaced with a sample name or a credential type.

export const MISSING_VALUE = "-";

/** The professional's name on a request, or "-" when it has none. */
export function requestCandidateName(request) {
  const name = [
    request?.professional?.firstName,
    request?.professional?.lastName,
  ]
    .filter(Boolean)
    .join(" ")
    .trim();
  return name || MISSING_VALUE;
}

/** The credential's title on a request, or "-" when it has none. */
export function requestCredentialTitle(request) {
  return request?.credential?.title || MISSING_VALUE;
}

/** True when an application file came with the list (a data: URL). */
export function isAttachedFile(dataUrl) {
  return typeof dataUrl === "string" && dataUrl.startsWith("data:");
}

/** The name of an application file, or what to say when there is none. */
export function attachmentLabel(fileName, dataUrl) {
  if (fileName) return fileName;
  return isAttachedFile(dataUrl) ? "Attached file" : "No file attached";
}
